import React from "react";
import { calculateDisplayedPrice } from "../../utils/calculateDisplayedPrice";
import { useCalculateValidPrice } from "../../hooks/useCalculateValidPrice";

export default function SideProductPrice(props) {
  // PROPS COMING FROM SideProductModalContent
  const {
    isThereApendingOrder,
    qty,
    choosen,
    // cartSkuItems,
    isDiscountValid,
    // remainingTime,
  } = props;

  // CALCULATE THE VALID PRICE
  const validPrice = useCalculateValidPrice(choosen, isDiscountValid);

  return (
    <div className="col w100p fs15">
      {/* COMPARING CART ITEMS COUNT TO BRING IN THE CORRECT PRICE OFFER */}
      {
        choosen.timeLimitedDiscount?.discountAmount === 0 &&
        isThereApendingOrder !== "YES" ? (
          <p>{calculateDisplayedPrice(choosen.price)} TL</p>
        ) : isThereApendingOrder === "YES" && qty > "0" ? (
          <div className="row w60p">
            <strike className="red-col">
              {calculateDisplayedPrice(choosen.price, qty)}
            </strike>
            <p>{calculateDisplayedPrice(choosen.priceGap, qty)} TL</p>
          </div>
        ) : isThereApendingOrder === "YES" ? (
          <div className="row w60p">
            <strike className="red-col">
              {calculateDisplayedPrice(choosen.price)}
            </strike>
            <p> {calculateDisplayedPrice(choosen.priceGap)} TL</p>
          </div>
        ) : isDiscountValid ? (
          <div className="row w60p">
            <strike className="red-col">
              {calculateDisplayedPrice(choosen.price)}
            </strike>
            <p>{calculateDisplayedPrice(validPrice)} TL</p>
          </div>
        ) : (
          <div>
            <p>{calculateDisplayedPrice(choosen.price)} TL</p>
          </div>
        ) /*: qty === 0 && cartSkuItems.length === 0 ? (
        <span className="h2c">{calculateDisplayedPrice(choosen.price)} TL</span>
      ) : qty === "0" && cartSkuItems.length === 0 ? (
        <span className="h2c">{calculateDisplayedPrice(choosen.price)} TL</span>
      ) : qty === "1" && cartSkuItems.length === 0 ? (
        <span className="h2c">{calculateDisplayedPrice(choosen.price)} TL</span>
      ) : cartSkuItems.length === 0 && qty > "1" ? (
        <>
          <strike className="h2c red-col">
            {calculateDisplayedPrice(choosen.price, qty)} TL
          </strike>
          <span className="h2c">
            {calculateDisplayedPrice(choosen.price, qty, choosen.priceGap)} TL
          </span>
        </>
      ) : cartSkuItems.length >= 1 && qty === 0 ? (
        <>
          <strike className="h2c red-col">
            {calculateDisplayedPrice(choosen.price)} TL
          </strike>
          <span className="h2c">
            {calculateDisplayedPrice(choosen.priceGap)} TL
          </span>
        </>
      ) : cartSkuItems.length >= 1 && qty === "0" ? (
        <>
          <strike className="h2c red-col">
            {calculateDisplayedPrice(choosen.price)} TL
          </strike>
          <span className="h2c">
            {calculateDisplayedPrice(choosen.priceGap)} TL
          </span>
        </>
      ) : (
        cartSkuItems.length >= 1 &&
        qty > 0 && (
          <>
            <strike className="h2c red-col">
              {calculateDisplayedPrice(choosen.price, qty)} TL
            </strike>
            <span className="h2c">
              {calculateDisplayedPrice(choosen.priceGap, qty)} TL
            </span>
          </>
        )
        )*/
      }
    </div>
  );
}
